/* tslint:disable */
/* eslint-disable */
/**
 * Mercatus Portal
 * Mercatus Portal
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@gomercatus.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { PowerBiCloneReportRequest } from '../model';
// @ts-ignore
import { PowerBiEmbedConfig } from '../model';
// @ts-ignore
import { PowerBiEmbedToken } from '../model';
// @ts-ignore
import { PowerBiExportFormData } from '../model';
// @ts-ignore
import { PowerBiExportResponse } from '../model';
// @ts-ignore
import { PowerBiExportStatus } from '../model';
// @ts-ignore
import { PowerBiReport } from '../model';
// @ts-ignore
import { PowerBiWorkspaceReportsResponse } from '../model';
/**
 * PowerBiApi - axios parameter creator
 * @export
 */
export const PowerBiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Clone an existing reportId
         * @param {string} reportId reportID
         * @param {PowerBiCloneReportRequest} [powerBiCloneReportRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cloneReport: async (reportId: string, powerBiCloneReportRequest?: PowerBiCloneReportRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'reportId' is not null or undefined
            assertParamExists('cloneReport', 'reportId', reportId)
            const localVarPath = `/shared/powerbi/reports/{reportId}/clone`
                .replace(`{${"reportId"}}`, encodeURIComponent(String(reportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(powerBiCloneReportRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Requests a dataset refresh for a reportId
         * @param {string} reportId reportID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doReportDatasetRefresh: async (reportId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'reportId' is not null or undefined
            assertParamExists('doReportDatasetRefresh', 'reportId', reportId)
            const localVarPath = `/shared/powerbi/reports/{reportId}/refresh`
                .replace(`{${"reportId"}}`, encodeURIComponent(String(reportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets the embed config for the current user using the org workspace and credentials
         * @param {string} reportId reportID
         * @param {string} [datasetId] datasetId to pass if report is paginated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmbedConfig: async (reportId: string, datasetId?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'reportId' is not null or undefined
            assertParamExists('getEmbedConfig', 'reportId', reportId)
            const localVarPath = `/shared/powerbi/reports/{reportId}/config`
                .replace(`{${"reportId"}}`, encodeURIComponent(String(reportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (datasetId !== undefined) {
                localVarQueryParameter['datasetId'] = datasetId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets the list of reports for the org workspace
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspaceReports: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/shared/powerbi/reports`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets a new embed token the current user using the org workspace and credentials
         * @param {string} reportId 
         * @param {string} [datasetId] datasetId to pass if report is paginated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshEmbedTokens: async (reportId: string, datasetId?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'reportId' is not null or undefined
            assertParamExists('refreshEmbedTokens', 'reportId', reportId)
            const localVarPath = `/shared/powerbi/reports/{reportId}/refreshEmbedToken`
                .replace(`{${"reportId"}}`, encodeURIComponent(String(reportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (datasetId !== undefined) {
                localVarQueryParameter['datasetId'] = datasetId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Requests a dataset refresh for a reportId
         * @param {string} reportId reportID
         * @param {PowerBiExportFormData} [powerBiExportFormData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportExport: async (reportId: string, powerBiExportFormData?: PowerBiExportFormData, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'reportId' is not null or undefined
            assertParamExists('reportExport', 'reportId', reportId)
            const localVarPath = `/shared/powerbi/reports/{reportId}/export`
                .replace(`{${"reportId"}}`, encodeURIComponent(String(reportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(powerBiExportFormData, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets the file generated by an export request
         * @param {string} reportId reportID
         * @param {string} exportId exportID from the export request of the completed file
         * @param {'PDF' | 'PPTX' | 'PNG'} fileType string value of the export file type
         * @param {string} fileName string value of the filename to use
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportExportFile: async (reportId: string, exportId: string, fileType: 'PDF' | 'PPTX' | 'PNG', fileName: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'reportId' is not null or undefined
            assertParamExists('reportExportFile', 'reportId', reportId)
            // verify required parameter 'exportId' is not null or undefined
            assertParamExists('reportExportFile', 'exportId', exportId)
            // verify required parameter 'fileType' is not null or undefined
            assertParamExists('reportExportFile', 'fileType', fileType)
            // verify required parameter 'fileName' is not null or undefined
            assertParamExists('reportExportFile', 'fileName', fileName)
            const localVarPath = `/shared/powerbi/reports/{reportId}/exports/{exportId}/file`
                .replace(`{${"reportId"}}`, encodeURIComponent(String(reportId)))
                .replace(`{${"exportId"}}`, encodeURIComponent(String(exportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (fileType !== undefined) {
                localVarQueryParameter['fileType'] = fileType;
            }

            if (fileName !== undefined) {
                localVarQueryParameter['fileName'] = fileName;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets the status of a report export in progress
         * @param {string} reportId reportID
         * @param {string} exportId exportID from the export request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportExportStatus: async (reportId: string, exportId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'reportId' is not null or undefined
            assertParamExists('reportExportStatus', 'reportId', reportId)
            // verify required parameter 'exportId' is not null or undefined
            assertParamExists('reportExportStatus', 'exportId', exportId)
            const localVarPath = `/shared/powerbi/reports/{reportId}/exports/{exportId}`
                .replace(`{${"reportId"}}`, encodeURIComponent(String(reportId)))
                .replace(`{${"exportId"}}`, encodeURIComponent(String(exportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PowerBiApi - functional programming interface
 * @export
 */
export const PowerBiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PowerBiApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Clone an existing reportId
         * @param {string} reportId reportID
         * @param {PowerBiCloneReportRequest} [powerBiCloneReportRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cloneReport(reportId: string, powerBiCloneReportRequest?: PowerBiCloneReportRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PowerBiReport>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cloneReport(reportId, powerBiCloneReportRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Requests a dataset refresh for a reportId
         * @param {string} reportId reportID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async doReportDatasetRefresh(reportId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.doReportDatasetRefresh(reportId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Gets the embed config for the current user using the org workspace and credentials
         * @param {string} reportId reportID
         * @param {string} [datasetId] datasetId to pass if report is paginated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmbedConfig(reportId: string, datasetId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PowerBiEmbedConfig>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEmbedConfig(reportId, datasetId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Gets the list of reports for the org workspace
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWorkspaceReports(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PowerBiWorkspaceReportsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkspaceReports(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Gets a new embed token the current user using the org workspace and credentials
         * @param {string} reportId 
         * @param {string} [datasetId] datasetId to pass if report is paginated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async refreshEmbedTokens(reportId: string, datasetId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PowerBiEmbedToken>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.refreshEmbedTokens(reportId, datasetId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Requests a dataset refresh for a reportId
         * @param {string} reportId reportID
         * @param {PowerBiExportFormData} [powerBiExportFormData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportExport(reportId: string, powerBiExportFormData?: PowerBiExportFormData, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PowerBiExportResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportExport(reportId, powerBiExportFormData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Gets the file generated by an export request
         * @param {string} reportId reportID
         * @param {string} exportId exportID from the export request of the completed file
         * @param {'PDF' | 'PPTX' | 'PNG'} fileType string value of the export file type
         * @param {string} fileName string value of the filename to use
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportExportFile(reportId: string, exportId: string, fileType: 'PDF' | 'PPTX' | 'PNG', fileName: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportExportFile(reportId, exportId, fileType, fileName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Gets the status of a report export in progress
         * @param {string} reportId reportID
         * @param {string} exportId exportID from the export request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportExportStatus(reportId: string, exportId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PowerBiExportStatus>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportExportStatus(reportId, exportId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PowerBiApi - factory interface
 * @export
 */
export const PowerBiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PowerBiApiFp(configuration)
    return {
        /**
         * 
         * @summary Clone an existing reportId
         * @param {string} reportId reportID
         * @param {PowerBiCloneReportRequest} [powerBiCloneReportRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cloneReport(reportId: string, powerBiCloneReportRequest?: PowerBiCloneReportRequest, options?: any): AxiosPromise<PowerBiReport> {
            return localVarFp.cloneReport(reportId, powerBiCloneReportRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Requests a dataset refresh for a reportId
         * @param {string} reportId reportID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doReportDatasetRefresh(reportId: string, options?: any): AxiosPromise<void> {
            return localVarFp.doReportDatasetRefresh(reportId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets the embed config for the current user using the org workspace and credentials
         * @param {string} reportId reportID
         * @param {string} [datasetId] datasetId to pass if report is paginated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmbedConfig(reportId: string, datasetId?: string, options?: any): AxiosPromise<PowerBiEmbedConfig> {
            return localVarFp.getEmbedConfig(reportId, datasetId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets the list of reports for the org workspace
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkspaceReports(options?: any): AxiosPromise<PowerBiWorkspaceReportsResponse> {
            return localVarFp.getWorkspaceReports(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets a new embed token the current user using the org workspace and credentials
         * @param {string} reportId 
         * @param {string} [datasetId] datasetId to pass if report is paginated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshEmbedTokens(reportId: string, datasetId?: string, options?: any): AxiosPromise<PowerBiEmbedToken> {
            return localVarFp.refreshEmbedTokens(reportId, datasetId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Requests a dataset refresh for a reportId
         * @param {string} reportId reportID
         * @param {PowerBiExportFormData} [powerBiExportFormData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportExport(reportId: string, powerBiExportFormData?: PowerBiExportFormData, options?: any): AxiosPromise<PowerBiExportResponse> {
            return localVarFp.reportExport(reportId, powerBiExportFormData, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets the file generated by an export request
         * @param {string} reportId reportID
         * @param {string} exportId exportID from the export request of the completed file
         * @param {'PDF' | 'PPTX' | 'PNG'} fileType string value of the export file type
         * @param {string} fileName string value of the filename to use
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportExportFile(reportId: string, exportId: string, fileType: 'PDF' | 'PPTX' | 'PNG', fileName: string, options?: any): AxiosPromise<void> {
            return localVarFp.reportExportFile(reportId, exportId, fileType, fileName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets the status of a report export in progress
         * @param {string} reportId reportID
         * @param {string} exportId exportID from the export request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportExportStatus(reportId: string, exportId: string, options?: any): AxiosPromise<PowerBiExportStatus> {
            return localVarFp.reportExportStatus(reportId, exportId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PowerBiApi - object-oriented interface
 * @export
 * @class PowerBiApi
 * @extends {BaseAPI}
 */
export class PowerBiApi extends BaseAPI {
    /**
     * 
     * @summary Clone an existing reportId
     * @param {string} reportId reportID
     * @param {PowerBiCloneReportRequest} [powerBiCloneReportRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PowerBiApi
     */
    public cloneReport(reportId: string, powerBiCloneReportRequest?: PowerBiCloneReportRequest, options?: any) {
        return PowerBiApiFp(this.configuration).cloneReport(reportId, powerBiCloneReportRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Requests a dataset refresh for a reportId
     * @param {string} reportId reportID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PowerBiApi
     */
    public doReportDatasetRefresh(reportId: string, options?: any) {
        return PowerBiApiFp(this.configuration).doReportDatasetRefresh(reportId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets the embed config for the current user using the org workspace and credentials
     * @param {string} reportId reportID
     * @param {string} [datasetId] datasetId to pass if report is paginated
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PowerBiApi
     */
    public getEmbedConfig(reportId: string, datasetId?: string, options?: any) {
        return PowerBiApiFp(this.configuration).getEmbedConfig(reportId, datasetId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets the list of reports for the org workspace
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PowerBiApi
     */
    public getWorkspaceReports(options?: any) {
        return PowerBiApiFp(this.configuration).getWorkspaceReports(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets a new embed token the current user using the org workspace and credentials
     * @param {string} reportId 
     * @param {string} [datasetId] datasetId to pass if report is paginated
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PowerBiApi
     */
    public refreshEmbedTokens(reportId: string, datasetId?: string, options?: any) {
        return PowerBiApiFp(this.configuration).refreshEmbedTokens(reportId, datasetId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Requests a dataset refresh for a reportId
     * @param {string} reportId reportID
     * @param {PowerBiExportFormData} [powerBiExportFormData] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PowerBiApi
     */
    public reportExport(reportId: string, powerBiExportFormData?: PowerBiExportFormData, options?: any) {
        return PowerBiApiFp(this.configuration).reportExport(reportId, powerBiExportFormData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets the file generated by an export request
     * @param {string} reportId reportID
     * @param {string} exportId exportID from the export request of the completed file
     * @param {'PDF' | 'PPTX' | 'PNG'} fileType string value of the export file type
     * @param {string} fileName string value of the filename to use
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PowerBiApi
     */
    public reportExportFile(reportId: string, exportId: string, fileType: 'PDF' | 'PPTX' | 'PNG', fileName: string, options?: any) {
        return PowerBiApiFp(this.configuration).reportExportFile(reportId, exportId, fileType, fileName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets the status of a report export in progress
     * @param {string} reportId reportID
     * @param {string} exportId exportID from the export request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PowerBiApi
     */
    public reportExportStatus(reportId: string, exportId: string, options?: any) {
        return PowerBiApiFp(this.configuration).reportExportStatus(reportId, exportId, options).then((request) => request(this.axios, this.basePath));
    }
}
